export const reportNumDisp = (reportNum) => {
  if (!reportNum) { return '' }
  const parts = reportNum.split('-')
  if (parts.length !== 4) { return '' }
  return parts[3]
}
